<ng-template #content let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">Add Folder</h5>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button> -->
  </div>
  <div class="modal-body">
    <!-- <form #folderForm="ngForm"> -->
    <div class="row">
      <div class="col-sm-2">
        <label for="folderName" class="col-form-label">Folder Name </label>
      </div>
      <div class="col-sm-5">
        <input type="text" class="form-control" required name="folderName" [(ngModel)]="documentModel.name" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-sm-2">
        <label class="col-form-label">Role</label>
      </div>
      <div class="col-sm-5">
        <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedRole" (change)="onRoleChange()">
          <option [ngValue]="null">Select Role</option>
          <option *ngFor="let role of roleList" [ngValue]="role">
            {{ role.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-sm-2">
        <label class="col-form-label">Service Vertical</label>
      </div>
      <div class="col-sm-5">
        <select class="form-control form-control-xs mt-1" name="serviceVertical" [(ngModel)]="selectedServiceVertical"
          (change)="onServiceVerticalChange()" [disabled]="!selectedRole || selectedRole?.name === 'Article'">
          <option [ngValue]="null">Select Service Vertical</option>
          <option *ngFor="let serviceVertical of serviceVerticalList" [ngValue]="serviceVertical">
            {{ serviceVertical.name }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <table class="table table-striped table-bordered mt-4" *ngIf="documentModel.access.length > 0">
        <thead>
          <th>Role</th>
          <th>Service Vertical</th>
          <th>Read</th>
          <th>Write</th>
          <th></th>
        </thead>
        <tbody *ngFor="let role of documentModel.access; let i = index">
          <td>{{ role.role.name }}</td>
          <td *ngIf="role.serviceVertical">{{ role.serviceVertical.name }}</td>
          <td *ngIf="!role.serviceVertical">-</td>
          <td>
            <input type="checkbox" disabled [(ngModel)]="role.readAccess" />
          </td>
          <td>
            <input type="checkbox" [(ngModel)]="role.writeAccess" />
          </td>
          <td (click)="deleteRoleRow(i)">
            <i class="fa fa-remove fa-2x" style="color: red; cursor: pointer"></i>
          </td>
        </tbody>
      </table>
    </div>
    <!-- </form> -->
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>

      <div class="col-sm-3">
        <button id="updatePersonalDetailsBtn" name="updatePersonalDetailsBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" *ngIf="!hideSaveButton" (click)="onSaveClick()">
          Save
        </button>

        <button id="updateAnnouncementDetail" name="updateAnnouncementDetailBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" *ngIf="hideSaveButton" (click)="onUpdateClick()">
          Update
        </button>
      </div>

      <div class="col-sm-3">
        <button id="closePersonalDetailsBtn" name="closePersonalDetailsBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" ngbAutofocus (click)="closeModel()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>